import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';

import Notifications, {notify} from 'react-notify-toast';
import swal from 'sweetalert';
import 'sweetalert/dist/sweetalert.css';
import SvgIcon from 'react-icons-kit';
import {print} from 'react-icons-kit/fa/print';
import ModalHistorico from '../../generics/ModalHistorico';
//import ModalIncidents from './ModalIncidents';
import {List} from 'material-ui/List';
import {eye} from 'react-icons-kit/icomoon/eye';
import moment from 'moment';
import {Typeahead} from 'react-bootstrap-typeahead';
import {pencilSquareO} from 'react-icons-kit/fa/pencilSquareO';
//import ModalNotes from './modalNotes';

import {lab} from 'react-icons-kit/icomoon/lab';
import IconInc from '../../../assets/icons/incident';
import Fields from '../../generics/fields';
import { formularioId, formularioRender } from '../../../libs/services';

//import CKEditor from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
const {htmlToText} = require('html-to-text');
var Config = require('../../../config');
const $ = require('jquery');

const style = {
  margin: 12,
};
const lastLocation = '';
class ClinicHistoryPatient extends Component{
	constructor(props, context) {
		super(props, context);
		this.saveHC = this.saveHC.bind(this);
		this.getAnswers = this.getAnswers.bind(this);
		this.cancel = this.cancel.bind(this);
		this.generatePDF = this.generatePDF.bind(this);
		this.completed = this.completed.bind(this);
		this.printConsent = this.printConsent.bind(this);
		this.acceptNum = this.acceptNum.bind(this);
		this.laboratory_print = this.laboratory_print.bind(this);
		this.updateForm = this.updateForm.bind(this);

		var aux_date = new Date();
		this.state = {
			enable_print:false,
			categories:[],
			clinic_history_id:"",
			IdFormulario:"",
			update:false,
			date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			show_group_rh:false,
			today:"",
			notForm:false,
			preview_print: {},
			show_finish:false,
			staff_date: "",
			auto_print_hc:{},


            petition_id:"",
            patient_name:"",
            patient_sex:"",
            petition_number:"",
            clinic_history:"",
            petition_type:""
		};
	}

	componentDidMount() {
		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);
		    if(res.Error !== undefined){
		    	swal('¡Error!', res.Error, 'error');
		    }
		}

		//Get Current Date from Server
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                console.log(result);
              });
            }})
		.then(response => {
			var aux = response.split('|');
			this.setState({
				today:aux[0]
			});
		})

		this.props.waiting.handleShow('Cargando...');
		this.setState({ 
            petition_id:this.props.match.params.id,
			update:false,
        });
		
		fetch(Config.default.apiGateway.URL+'petitions/patient_info/'+this.props.match.params.id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', 'No se pudo consultar informacion del donante', 'error');
              });
            }})
		.then(async response => {
			if(response !== null && response!==undefined){
				await this.setState({
                    patient_name: response.lastname1+' '+response.lastname2+' '+response.names,
                    patient_sex:response.sex,
                    petition_number: response.petition_number,
                    clinic_history: response.clinic_history,
                    petition_type: response.petition_type
                });

                await this.getFormulario(response.sex, response.clinic_history_form_id);
			}
		})

		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		})

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=AUTO_PRINT_HC',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				auto_print_hc: response
			});
		})
	}

	async getFormulario(sex, form_id){
		var response;

		if(form_id === 0){
			response = await formularioRender(sessionStorage.getItem("health_facilities_id"), sex, false, '');
		}else{
			response = await formularioId(form_id, sex);
		}

		if(response !== undefined){
			this.setState({categories: response.sections, IdFormulario: response.id})
			this.getValuesHC();
		}else{
			this.setState({notForm:true})
		}
	}

	getValuesHC(){
		fetch(Config.default.apiGateway.URL+'patient_clinic_history?petition_id='+this.state.petition_id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}console.log(res)})
		.then(response => {
			if(response !== undefined ){
                var categories = this.state.categories;

                categories.forEach((cat)=>{
                    cat.fields.forEach((field)=>{
                        var index = response.patient_clinic_history_values.findIndex(obj => obj.field_id === field.field_id);

                        if(index !== -1){
                            field.default_value = response.patient_clinic_history_values[index].value;
                        }
                    })
                })

                this.setState({
					clinic_history_id: response.id,
                    categories: categories,
                    update:true,
                    enable_print:true
				});
			}else{
                this.setState({update:false})
            }
		})
	}

	saveHC(e){
		e.preventDefault();
		if(this.isValidForm()){
			var obj = {};

            if(!this.state.update){
                obj = {
                    petition_id: this.state.petition_id,
                    patient_clinic_history_values: this.getAnswers(),
					form_id:this.state.IdFormulario
                }
            }else{
                obj = this.getAnswers();
            }			
            
            this.completed(obj);
		}else{
			swal('Error', 'Campos Incompletos','error');
		}
	}

	completed(obj){
		var route = "",method_type="",msg="";
		//this.props.waiting.handleShow('Guardando...');
		if(!this.state.update){//DAR DE ALTA POST
			route = 'patient_clinic_history';
			method_type = "POST";
			msg = "Historia Clínica Guardada";
		}else{//ACTUALIZAR PUT
			route = 'patient_clinic_history/'+this.state.clinic_history_id;
			method_type = "PUT";
			msg = "Historia Clínica Actualizada";
		}

		fetch(Config.default.apiGateway.URL+route, {
		  method: method_type, // or 'PUT'
		  body: JSON.stringify(obj), // data can be `string` or {object}!
		  headers: new Headers({
		  	'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
		  	'Accept': 'application/json',
		  	'Content-Type': 'application/json;charset=UTF-8'
		  })
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}console.log(res)})
		.catch(error => console.error('Error:', error))
		.then(response => {
	    	if(response !== undefined){
	    		swal('¡Buen Trabajo!', msg,'success');
	    		this.setState({
                    clinic_history_id:response,
                    enable_print:true,
                    update:true
                });
	    	}else{
	    		notify.show('Error, No se pudo guardar','error');
	    	}
		});
	}

	//Verificar si el formulario es valido
	isValidForm() {
		var ctrls = [];
   		if(this.state.valoration === 'NOT_RESULTS'){
   			const select = document.querySelector('div.conclusion');
   			ctrls = select.querySelectorAll('input, select');
   		}else{
   			ctrls = document.querySelectorAll('input,select');
   		}
		

	    let isFormValid = true;

    	 ctrls.forEach(ctrl => {
	    	if(ctrl.required){
		      	const isInputValid = this.showCtrlError(ctrl.id);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });
	   
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		
		if(control !== null){

			if (control.value === "") {
		        if(control !== null){
		            control.classList.add('error');
		        }
				res = false;
			} else{
				if(control !== null){
					if(control.required && control.className.includes('error')){
			        	control.classList.remove('error');
			    	}
		    	}
				res = true;
			}
		}

		return res;
	}

	getAnswers(){
		var obj = {}, res =[];
		this.state.categories.forEach((cat)=>{
			cat.fields.forEach((field)=>{
				var obj = {
					value: field.default_value,
					field_id: field.field_id,
					form_id: this.state.IdFormulario
				};

				/*if(field.type_name === 'Fecha'){
					if(obj.value.length > 0){
						var aux_date = new Date(obj.Valor.split(/\//).reverse().join('/'));
						if(aux_date.toString() === 'Invalid Date'){
							swal('Formato de fecha no válido', 'PREGUNTA => "'+field.Etiqueta+'"','error');
							return null;
						}else{
							obj.Valor = aux_date;
						}
					}
				}*/

				res.push(obj);
			})
		})

		return res;
	}

	cancel(e){
		e.preventDefault();
		setTimeout(()=>{
			this.props.history.goBack();
		}, 500);
	}

	getItemValue(id){
		return document.getElementById(id).value;
	}
	
	generatePDF(e){
		e.preventDefault();
		if(this.state.clinic_history_id !== ""){
			this.props.waiting.handleShow('Generando...');
			var url = "patient_clinic_history/print/"+this.state.clinic_history_id;

			fetch(Config.default.apiGateway.URL+url, {
				method : 'post',
				responseType: 'blob', //Force to receive data in a Blob Format
				headers : new Headers({
					'Authorization': 'Bearer '+sessionStorage.getItem('token'),
					'Content-Type': 'application/pdf'
				})
			})
			.then(res => {
		      this.props.waiting.handleClose();
		          if(res.ok){
		            return res.blob();
		          }else{
		            res.text().then(function(error) {
		              swal('¡Error!', "No ha sido posible imprimir", 'error');
		            });
		        }
		    })
			.then(response => {
				if(response !== undefined){
					if(this.state.auto_print_hc.value === "NO"){
						//PREVIEW
						var fileURL = URL.createObjectURL(response);
						window.open(fileURL);
					}else{
						this.directPrint(response);	
					}
	       		}
			})
		}
    }


	async printConsent(e){
		e.preventDefault();
		if(this.state.clinic_history_id !== ""){
			this.props.waiting.handleShow('Imprimiendo...');
				
			var obj ={};
			obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
			obj.id = this.state.petition_id;
			obj.file_type = 'INFORMED_CONSENT_'+this.state.petition_type;
			obj.nEtiqueta = [0];

			var type = await this.props.getDocumentType(obj.file_type);

			var document;
			if(type.print_type === 'template'){
				document = await this.props.printDocumentTemplate(obj, type.print_automatically);
			}else if(type.print_type === 'external'){
				document = await this.props.printDocumentExternal(obj, type.print_automatically);
			}

			this.props.waiting.handleClose();
			if(document !== undefined){				
				this.setState({ show: false});			
			}

			
		}else{
			swal('¡Error!', "Primero debe guardar la Historia Clínica", 'error');
		}
	}	

	directPrint(response){
		//PRINTER
		var reader = new FileReader();
		reader.readAsDataURL(response); 
		reader.onloadend = ()=>{
			var base64data = reader.result;  
			var aux = base64data.split(',');
			this.props.socket.send('{"Operacion":"print", "Type":"clinic_history", "File": "'+aux[1]+'"}');
		}
	}

	concatGroupRH(){
		var res = "";
		if(this.state.donor.offer.group_test === null){
			if(this.state.donor.person.lookup_rh==="POSITIVO"){
				res = this.state.donor.person.lookup_group+'+'
			}else{
				res = this.state.donor.person.lookup_group+'-'
			}
		}else{
			if(this.state.donor.offer.group_test.RH==="POSITIVO"){
				res = this.state.donor.offer.group_test.group+'+'
			}else{
				res = this.state.donor.offer.group_test.group+'-'
			}
		}
		if(res.length>0){
			if(this.state.donor.offer.group_test !== null){
				if(this.state.donor.offer.group_test.lectina !== null){
					var position = 1;
					res = [res.slice(0, position), this.state.donor.offer.group_test.lectina, res.slice(position)].join('');
				}
			}
		}


		return res;
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;

      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined){

      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
      				if(form.elements[index + 1].getAttribute("name") !== null){
      					if(form.elements[index + 1].getAttribute("disabled") === null)
	    					form.elements[index + 1].focus();
	    			
	    				else if(form.elements[index + 1].getAttribute("disabled") === "")
	    					form.elements[index + 2].focus();
      				}else{
      					form.elements[index + 2].focus();
    				}
      			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	acceptNum(e){//Sólo números y SÓLO 1 punto decimal
		if(e.key === 'Enter'){
			this.validateInput(e);
		}else{
			// Punto = 46
			var key = e.which;
			var cadena= e.target.value
			if(cadena.indexOf('.')===-1){
				if(key <= 13 || (key >= 48 && key <= 57) || key === 46){
					return;
				}else{
					e.preventDefault();
				}
			}else{
				if(key <= 13 || (key >= 48 && key <= 57)){
					return;
				}else{
					e.preventDefault();
				}
			}
		}
	}

	laboratory_print(e, ){
		e.preventDefault();

		fetch(Config.default.apiGateway.URL+'html_templates?health_facilities_id='+
			sessionStorage.getItem("health_facilities_id")+'&file_type=area_laboratory&extraction_type=',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
			  'Content-Type': 'application/json',
			})
		})
		.then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(result) {
				  swal('¡Error', result, 'error');
				});
			}
		})
		.then(async response => {
			if(response.res === 0){
				swal('¡Error!', "No se ha definido ningún formato de impresión", 'error');
			}else{
				this.props.waiting.handleShow('Imprimiendo...');
		  
				var obj ={};
				obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
				obj.id = this.state.donor.donation_id;
				obj.file_type = "area_laboratory";
				obj.nEtiqueta = [0];

				var type = await this.props.getDocumentType(obj.file_type);

				var document;
				if(type.print_type === 'template'){
					document = await this.props.printDocumentTemplate(obj, type.print_automatically);
				}else if(type.print_type === 'external'){
					document = await this.props.printDocumentExternal(obj, type.print_automatically);
				}

				this.props.waiting.handleClose();
				if(document !== undefined){					
					this.setState({ show: false});
				}
				
			}
		})
  	}

	updateForm(e, i, j){
		var categories = this.state.categories;
		
		categories[i].fields[j].default_value = e.target.value;

		this.setState({categories: categories});
	}

	render(){
		const { t } = this.props;
		return(
			<div className="col-xs-12">

				<div className="route">
					<h5 className="title_page">
					  {sessionStorage.getItem('health_facilities_name')} ->			              
		              {t('sidebar.nav.patients.MAIN')} ->
		              {t('content.modal_hc.MAIN')}
		            </h5>
		        </div>
				<form id="form_hc">
		        	<div className="col-xs-12" style={{padding:"0px"}}>
                        <div className="col-xs-12" style={{padding:"0px"}}>
                            <fieldset>
                                <legend>Datos generales</legend>
                                <div className="col-xs-12">
                                    <div className="col-xs-12 col-sm-2" style={{textAlign:"right", marginTop:"10px"}}>
                                        <span className="span-min">Expediente</span>
                                    </div>
                                    <div className="col-xs-12 col-sm-6">
                                        <span className="patient-name" style={{marginRight:"20px"}}>{this.state.clinic_history}</span>
                                    </div>
                                </div>
                                <div className="col-xs-12">
                                    <div className="col-xs-12 col-sm-2" style={{textAlign:"right", marginTop:"10px"}}>
                                        <span className="span-min">Nombre de Paciente</span>
                                    </div>
                                    <div className="col-xs-12 col-sm-6">
                                        <span className="patient-name" style={{marginRight:"20px"}}>{this.state.patient_name}</span>

                                        <span style={{color:"red", fontWeight:"bold", fontSize:"25px"}}>{this.state.group_rh}</span>
                                    </div>
                                </div>
                                <div className="col-xs-12 form-group">
                                    <div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
                                        <span className="span-min">Género</span>
                                    </div>
                                    <div className="col-xs-12 col-sm-9">
                                        <span className="color-font">{this.state.patient_sex}</span>
                                    </div>
                                </div>
                                
                            </fieldset>
                        </div>

                        <div className="col-xs-12">
                            {this.state.categories.map((cat, i)=>
                                <fieldset key={i}>
                                    <legend>{cat.section_name}</legend>
                                    <div className='d-flex flex-wrap form-group' style={{marginTop:10}}>
                                        {cat.fields.map((field, j)=>
                                            <Fields 
                                                key={j} 
                                                {...this.props} 
                                                field={field} 
                                                section={i} 
                                                index={j}
                                                updateForm={this.updateForm}
                                            />
                                        )}
                                    </div>
                                </fieldset>
                            )}
                        </div>
		        		
					
                        <div className="col-xs-12" style={{textAlign:"center",fontSize:".8em",padding:'0px'}}>
                            <div className="form-group" >
                                <button className="toolIcon" onClick={this.generatePDF} 
                                    disabled={!this.state.enable_print}>
                                    <SvgIcon size={40} icon={print} />
                                    <div>
                                    <span>{t('toolbar.print_hc')}</span>
                                    </div>
                                </button>

                                <button className="toolIcon" onClick={this.printConsent} disabled={!this.state.enable_print}>
                                    <SvgIcon size={40} icon={print} />
                                    <div>
                                    <span>{t('toolbar.print_con')}</span>
                                    </div>
                                </button>
                            </div>
                        </div>
                        {!this.state.show_finish?
                            <div className="col-xs-12" style={{textAlign:'center'}}>
                                <RaisedButton className="action-btn"
                                    type="submit" label={t('content.generics.buttons.save')} 
                                    style={style} onClick={this.saveHC} 
                                    disabled={this.notForm ? true :

                                        this.props.task_clinic_history.create ? this.state.exist_extraction  : 
                                        this.props.task_clinic_history.update ? this.state.exist_extraction ? true : false  : true}
                                />
                                <RaisedButton className="action-btn" label={t('content.generics.buttons.return')} style={style} 
                                    onClick={this.cancel}
                                />
                            </div>
                        :
                            <div className="col-xs-12" style={{textAlign:'center'}}>
                                <RaisedButton className="action-btn" label={t('content.generics.buttons.finish')} style={style} 
                                    onClick={this.cancel}
                                />
                            </div>
                        }
                    </div>
		        </form>
				<ModalHistorico {...this.props} onRef={ref => (this.modal_historico = ref)} directPrint={this.directPrint}/>
		      	<Notifications />
	      	</div>
		);
	}
}

export default translate('translations')(ClinicHistoryPatient) 